import { IExpert } from "../types/experts";

export const EXPERTS: IExpert[] = [
  {
    id: "1",
    name: "Evgenii",
    description: "expert_1",
    image: "/images/team/expert_1.webp",
  },
  {
    id: "2",
    name: "Anton",
    description: "expert_2",
    image: "/images/team/expert_2.webp",
  },
  {
    id: "3",
    name: "Pavel",
    description: "expert_3",
    image: "/images/team/expert_3.webp",
  },
  {
    id: "4",
    name: "Vladimir",
    description: "expert_4",
    image: "/images/team/expert_4.webp",
  },
];

export const MANAGEMENT_EXPERTS: IExpert[] = [
  {
    id: "1",
    name: "Tatiana",
    description: "management_expert_1",
    image: "/images/management/boiko.webp",
  },
  {
    id: "2",
    name: "Valentin",
    description: "management_expert_3",
    image: "/images/management/valentin.webp",
  },
];

export const RENT_EXPERTS: IExpert[] = [
  {
    id: "1",
    name: "Regina",
    description: "rent_expert_Regina",
    image: "/images/rent/experts/Regina.webp",
    mobileImage: "/images/rent/experts/Regina-mob.webp",
  },
  {
    id: "2",
    name: "Anna",
    description: "rent_expert_Anna",
    image: "/images/rent/experts/Anna.webp",
    mobileImage: "/images/rent/experts/Anna-mob.webp",
  },
  {
    id: "3",
    name: "Liana",
    description: "rent_expert_Liana",
    image: "/images/rent/experts/Liana.webp",
    mobileImage: "/images/rent/experts/Liana-mob.webp",
  },
  {
    id: "4",
    name: "Evgeniia",
    description: "rent_expert_Evgeniia",
    image: "/images/rent/experts/Evgeniia.webp",
    mobileImage: "/images/rent/experts/Evgeniia-mob.webp",
  },
  {
    id: "5",
    name: "Oksana",
    description: "rent_expert_Oksana",
    image: "/images/rent/experts/Oksana.webp",
    mobileImage: "/images/rent/experts/Oksana-mob.webp",
  },
];
